import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { trackClick } from "@/lib/analytics";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="relative border-t border-sky-100 bg-gradient-to-b from-white to-sky-50/60 pt-16 pb-10 px-6 lg:px-12">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-11 h-11 rounded-full bg-gradient-to-br from-sky-400 to-cyan-500 text-white flex items-center justify-center font-display shadow-md shadow-sky-200">AT</span>
            <span className="font-display text-xl tracking-wider text-slate-900">AI<span className="text-sky-500">AT</span> Studio</span>
          </div>
          <p className="text-slate-600 font-light leading-relaxed max-w-md">
            Studio Desain & Build Interior Premium berbasis AI. Dari ide hingga eksekusi —
            kami menerjemahkan visi ruangan Anda menjadi kenyataan.
          </p>
          <a
            href="https://www.instagram.com/atstudio.designbuild/"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackClick("footer_instagram")}
            data-testid="footer-ig"
            className="inline-flex items-center gap-2 mt-6 text-sky-600 hover:text-sky-700 text-sm"
          >
            <Instagram size={18} /> @atstudio.designbuild
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.25em] text-sky-600 mb-4 font-semibold">Hubungi</div>
          <ul className="space-y-3 text-sm text-slate-700">
            <li>
              <a
                href="https://wa.me/628119303015"
                target="_blank"
                rel="noreferrer"
                onClick={() => trackClick("footer_whatsapp")}
                className="flex items-center gap-3 hover:text-sky-600 transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={14} className="text-sky-500" /> +62 811 9303 015
              </a>
            </li>
            <li>
              <a href="mailto:tyasendybilly@gmail.com" className="flex items-center gap-3 hover:text-sky-600 transition-colors" data-testid="footer-email">
                <Mail size={14} className="text-sky-500" /> tyasendybilly@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={14} className="text-sky-500" /> Tangerang Selatan — BSD
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.25em] text-sky-600 mb-4 font-semibold">Studio</div>
          <p className="text-sm text-slate-700 leading-relaxed">
            Jl. SKKI No. 55 Priyang,<br />
            Pondok Jagung, Serpong Utara,<br />
            Tangerang Selatan
          </p>
          <a
            href="https://www.instagram.com/atstudio.designbuild/"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center w-10 h-10 mt-6 rounded-full bg-white border border-sky-100 text-sky-600 hover:bg-sky-500 hover:text-white hover:border-sky-500 transition-colors shadow-sm"
          >
            <Instagram size={18} />
          </a>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto border-t border-sky-100 pt-6 flex flex-col md:flex-row justify-between text-xs text-slate-500">
        <span>© {new Date().getFullYear()} AI AT Studio Design & Build. All rights reserved.</span>
        <span>Designed with intention.</span>
      </div>
    </footer>
  );
}
